if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
      }
    
      connectedCallback() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
  
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              this.closest('[data-related-product-ele]')?.classList.remove('d-none');
              if(this.dataset.url.indexOf('intent=complementary') > -1){
                const complementaryParent = document.querySelector('[data-complementaryitems]');
                complementaryParent.classList.remove('d-none');
              }
  
              let quickShopModal = document.querySelector('quick-shop');
              if(quickShopModal && typeof quickShopModal.updateEvents == 'function') quickShopModal.updateEvents(); 
              if (lazyImageObserver && typeof lazyImageObserver.observe === 'function') {
                lazyImageObserver.observe();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      }
  }
  customElements.define('product-recommendations', ProductRecommendations);
}